import axios from 'apiclient';

const priceRequest = (searchTerms) => axios.post('/api/price/',
  searchTerms)
  .then((res) => res.data);

export default priceRequest;
